import React from "react";

/**
 * @type {import("react").FC<import("react").DetailedHTMLProps>}
 */
const ColumnGroup = ({ ...props }) => {
  return <div {...props} />;
};

export default ColumnGroup;
